import { combineReducers } from 'redux';
import { HEADER_ISSHOW_SUCCESS,REQUEST_LOADING_SUCCESS } from "../action-types/userInfo";

const globalState = (state = {show:false}, action) => {
  if (action.type === HEADER_ISSHOW_SUCCESS) {
    return { ...state, ...action.data }
  }
  if (action.type === REQUEST_LOADING_SUCCESS) {
    return { ...state, ...action.data }
  }
  return state
}
export default combineReducers({
    globalState
})